import { useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import Button from '../Form/Button';
import { faStethoscope } from '@fortawesome/free-solid-svg-icons';

import './CreateProductModal.scss';
import Textarea from '../Form/Fields/Textarea';
import { API_BASE_URL } from '../../api';

export default function CreateMedicalServiceModal({
  medicalService,
  show,
  onClose,
  defaultValues = {},
  onSave
}) {
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (data) => {
    setIsLoading(true);

    const isEdit = !!medicalService?.id;
    const method = isEdit ? 'put' : 'post';
    const url = isEdit
      ? `${API_BASE_URL}/api/v1/updateMedicalService`
      : `${API_BASE_URL}/api/v1/addMedicalService`;

    const normalized = { ...data, price: parseFloat(data.price) || 0, isCommon: false };
    // The "code" field isn't editable in this form anymore — carry over the existing
    // value on edit instead of wiping it (updateMedicalService replaces the whole entity).
    const payload = isEdit ? { ...normalized, id: medicalService.id, code: medicalService.code } : normalized;

    axios[method](url, payload, { withCredentials: true })
      .then((response) => {
        onClose();
        toast.success(isEdit ? 'Service mis à jour avec succès !' : 'Service créé avec succès !');
        onSave?.(response.data);
      })
      .catch((error) => {
        const serverMsg = error?.response?.data?.message
          || error?.response?.data?.error
          || (typeof error?.response?.data === 'string' ? error.response.data : null)
          || `HTTP ${error?.response?.status ?? 'unknown'}`;
        toast.error(`Erreur: ${serverMsg}`);
        console.error('Error saving Medical Service:', error?.response?.status, error?.response?.data, error);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Modal
      id="createMedicalServiceModal"
      title={medicalService?.id ? 'Modifier le service' : 'Nouveau service'}
      show={show}
      onClose={onClose}
      icon={faStethoscope}
      iconBg="#FAEEDA"
      iconColor="#854F0B"
      footer={
        <Button
          isLoading={isLoading}
          loadingMessage="Enregistrement…"
          type="submit"
          form="createMedicalServiceForm"
          className="btn btn-primary"
        >
          {medicalService?.id ? 'Enregistrer les modifications' : 'Créer le service'}
        </Button>
      }
    >
      <Form id="createMedicalServiceForm" onSubmit={onSubmit} defaultValues={defaultValues}>

        <div className="cdm-section">
          <p className="cdm-section__label">Informations</p>

          <div className="mb-2">
            <label className="cdm-field-label">Nom du service <span className="text-danger">*</span></label>
            <InputText name="name" placeholder="Nom du service" validationRules={{ required: "Le nom est requis" }} />
          </div>

          <div>
            <label className="cdm-field-label">Tarif <span className="text-danger">*</span></label>
            <div className="cdm-price-wrapper">
              <InputText name="price" placeholder="0.00" validationRules={{ required: "Le tarif est requis" }} />
              <span className="cdm-price-badge">Dhs</span>
            </div>
          </div>

          <div className="mt-2">
            <label className="cdm-field-label">Description</label>
            <Textarea name="description" placeholder="Description du service" />
          </div>
        </div>

      </Form>
    </Modal>
  );
}
